import axios from 'axios';
import router from '../router';

const instance = axios.create({
    baseURL: 'http://localhost:10001',
    timeout: 360000,
    withCredentials: true
})

// request拦截器
instance.interceptors.request.use(
    config => {
        var token = localStorage.ms_token;
        if (token) {
            config.headers.Authorization = 'Bearer ' + token;
        }
        // config.headers.SessionId = localStorage.ms_sessionId;
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// respone拦截器
instance.interceptors.response.use(
    response => {
        if (response.data && response.data.state == true) {
            // localStorage.setItem("ms_token", response.data.Token);
            var expires = (new Date()).getTime() + 1000 * 60 * 60 * 10;
            localStorage.setItem("ms_token_expires", expires);
        }
        return response.data;
    },
    error => {
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    router.replace({
                        path: '/LoginTH'
                    });
                    // alert(error.response.data.message);
                    return false;
                    break;
                case 404:
                    break;
            }
        }
        return Promise.reject();
    }
);


export default instance



// WEBPACK FOOTER //
// ./src/api/index.js